export const InitDefaults = {
    string(schema) {
        return '';
    },
    number(schema) {
        return 0;
    },
    boolean(schema) {
        return false;
    },
    literal(schema) {
        return schema.value;
    },
    enum(schema) {
        return Object.values(schema.Enum)[0];
    },
    null(schema) {
        return null;
    },
    nullable(schema) {
        return null;
    },
    object(schema, overrides = {}) {
        const init = Object.keys(schema.shape).reduce((acc, key) => ({ ...acc, [key]: schema.shape[key].init() }), {});
        return { ...init, ...overrides };
    },
    array(schema) {
        return [];
    },
    record(schema) {
        return {};
    },
    union(schema) {
        return schema.options[0].init();
    },
    tuple(schema) {
        return schema.items.map((i) => i.init());
    },
    any() {
        return null;
    },
    optional(schema) {
        return undefined;
    },
    lazy(schema) {
        return schema._def.getter().init();
    },
    effects(schema) {
        return schema.innerType().init();
    }
};
